/**
 * @desc Guided tour
 * @example <div new-tour tour-init="true"></div>
 */

angular.
module('gplans.dashboard').
directive('newTour', newTour);

function newTour() {
  var directive = {
    templateUrl: 'templates/dashboard/new-tour.directive.html',
    restrict: 'AE',
    scope: {
      tourInit: '=',
      currentStep: '=',
      parent: '=',
      virtualSteps: "=",
      uniqueClass: "=",
      tourMisc: '=' },

    controller: NewTourController,
    controllerAs: 'vm',
    bindToController: true };

  return directive;
}

NewTourController.$inject = ['$rootScope', 'tourConfig', '$timeout', '$scope', 'Profile'];

function NewTourController($rootScope, tourConfig, $timeout, $scope, Profile) {
  var vm = this;
  vm.currentStep = null;
  tourConfig.animation = false;
  vm.showStep = showStep;
  vm.tourExit = tourExit;
  vm.stepBack = stepBack;
  vm.tourInit = false;
  vm.uniqueClass = '';
  vm.proceedStep = proceedStep;

  var flagWindowWidth = false;
  var fistShowFlag = false;
  var timeFirst = 2000;

  if (jQuery(window).width() < 1200) {
    flagWindowWidth = true;
  }

  $scope.$watch('vm.currentStep', function (newV, oldV) {
    console.log(newV, oldV);
    if (newV === 0) {
      vm.showStep();
      if (fistShowFlag === false) {
        $timeout(function () {
          jQuery('.custom-tour-tip').addClass('t-show animated ' + 't-count-' + vm.currentStep);
        }, 1600);
        fistShowFlag = true;
      }
    }
  });

  function proceedStep() {
    jQuery('body').removeClass(function (index, className) {
      return (className.match(/(^|\s)tour-go-\S+/g) || []).join(' ');
    });
    jQuery('.custom-tour-tip').removeClass(function (index, className) {
      return (className.match(/(^|\s)t-count-\S+/g) || []).join(' ');
    });
    jQuery('.tour-step, .sibling-tour').removeClass('is-show');
    jQuery('.custom-tour-tip').removeClass('t-show animated');
    jQuery('[class*="new-tour-"], [class*="new-sibl-"], [class*="new-select-"]').removeClass('is-show');
  }

  function showStep() {
    $timeout(function () {
      jQuery('body').addClass('tour-go-' + vm.currentStep);
      jQuery('.custom-tour-tip').addClass('t-show animated ' + 't-count-' + vm.currentStep);
      jQuery(vm.parent).addClass('tour-show');
      jQuery('.new-tour-' + vm.currentStep).addClass('is-show');
      jQuery('.new-sibl-' + vm.currentStep).addClass('is-show');
      jQuery('.new-select-' + vm.currentStep).addClass('is-show');
    });

    if (flagWindowWidth === true) {
      $timeout(function () {
        var step = jQuery('.tour-tip.custom-tour-tip.t-show').offset().top;
        $('html,body').animate({
          scrollTop: step - 10 },
        200);
        timeFirst = 500;
      }, timeFirst);
    }
  }

  function tourExit() {
    Profile.createMisc({ key: vm.tourMisc, value: '1' });
    jQuery(vm.parent).removeClass('tour-show').addClass('tour-exit');
    vm.tourInit = false;
    vm.currentStep = null;
    proceedStep();
  }

  function stepBack() {
    vm.currentStep -= 1;
  }
}